import { Trigger } from "@/generated";

import { CalendarClock } from "lucide-react";
import Image from "next/image";
import { useRemoteData } from "@/utils/useRemoteData";
import { DATA_KEYS } from "@/utils/useRemoteData";
import { useSpotUser } from "@/utils/spotUser";
import { keepPreviousData } from "@tanstack/react-query";

export const TriggersStack = ({ triggers }: { triggers?: Trigger[] }) => {
  const { spotGroup } = useSpotUser();
  const {
    data: triggerConfig,
    isLoading: isConfigLoading,
    isError: isConfigError,
  } = useRemoteData(
    DATA_KEYS.AVAILABLE_TRIGGERS,
    {
      path: { group_id: spotGroup.id },
    },
    { enabled: !!spotGroup.id, placeholderData: keepPreviousData }
  );

  if (!triggers || triggers?.length === 0) {
    return <></>;
  }
  return (
    <div className="flex gap-1">
      {triggers?.map((trigger) => (
        <div
          className="flex items-center justify-center p-1 rounded-md bg-muted"
          key={trigger.id}
          title={
            trigger.name ||
            triggerConfig?.triggers?.find(
              (t) => t.type === trigger.definition.type
            )?.title
          }
        >
          <div className="relative h-4 w-4">
            {trigger.definition.type == "schedule" ||
            trigger.definition.type == "schedule_v2" ? (
              <CalendarClock color="#203D54" size="1rem" strokeWidth="1.25px" />
            ) : !isConfigLoading ? (
              <Image
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
                src={
                  triggerConfig?.triggers?.find(
                    (t) => t.type === trigger.definition.type
                  )?.image || "/images/svg/page.svg"
                }
                alt="Trigger logo"
                fill
              />
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
};
